import { createContext, useContext } from 'react';
import { IAuthContext } from '@vivli/core/infrastructure/interface';

export const AuthContext = createContext<IAuthContext>(null);

export const useAuthEventsContext = () => useContext(AuthContext).authService.authEvents;
export const useAuthServiceContext = () => useContext(AuthContext).authService;
